
const tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
const firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

const initYoutubeVideos = (youtubeVideoHolder = '.js-youtube-video') => {
    const $youtubeVideos = $(youtubeVideoHolder);
    let player;

    if (!$youtubeVideos.length) {
        return
    }

    window.onYouTubeIframeAPIReady = function () {
        $youtubeVideos.each(function (index, el) {
            player = new YT.Player(this, {
                videoId: $(this).data('video-id'),
                widget_referrer: window.location.href,
                playerVars: {
                    controls: 0,
                    showinfo: 0,
                    modestbranding: 0,
                    autoplay: 1,
                    fs: 0,
                    cc_load_policy: 0,
                    iv_load_policy: 3,
                    autohide: 1,
                    rel: 0,
                    mute: 1,
                    start: 0,
                    enablejsapi: 0,
                    origin: window.location.href,
                    host: 'https://www.youtube.com',
                },
                events: {
                    onStateChange: function (e) {
                        if (e.data === YT.PlayerState.ENDED) {
                            const $slide = $(e.target.getIframe()).closest('.slick-slide');
                            const $billboardSlides = $slide.closest('.js-slider-billboards-mixed .slider__slides');

                            // Billboard videos play to completion, then advance to the next billboard
                            if ($billboardSlides.length && $slide.hasClass('slick-current') && $billboardSlides.slick('getSlick').slideCount > 1) {
                                $billboardSlides.slick('slickNext');
                                return;
                            }

                            e.target.mute();
                            player.seekTo(0);
                            e.target.playVideo();
                        }
                    },
                    onReady: function (e) {
                        if (e.target.h.closest('.slick-slide').classList.contains('slick-current')) {

                            e.target.mute();
                            e.target.playVideo();
                        } else {
                            e.target.mute();
                            e.target.stopVideo();
                        }
                    }
                }
            });
        });
    }
};

initYoutubeVideos();
